import React from "react";
import PropTypes from 'prop-types';

/**
 * To denote major sections of a page after the first section, use either the RegionCard title, or this floating RegionTitle component. There is a large variant for block-level regions and a small version for inline sections.
 */

export default function RegionTitle(props) {
  return props.smTitle ? (
    <h3 className="region-title-sm">{props.children}</h3>
  ) : (
    <h2 className="region-title-lg">{props.children}</h2>
  );
};

RegionTitle.propTypes = {
  /**
   * Flag to render smaller region title
   */
  smTitle: PropTypes.boolean
};
